import alt from "../alt";

class SystemStatesActions {
  constructor() {
    this.generateActions("fetchLocationData", "fetchFailed");
  }
}

export default alt.createActions(SystemStatesActions);



// WEBPACK FOOTER //
// ./src/app/actions/SystemStatesActions.js